var React = require('react');

function BackArrow (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M20.25 12H3.75","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M10.5 5.25L3.75 12L10.5 18.75","stroke":"currentColor","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

BackArrow.defaultProps = {"width":"100%","height":"100%","viewBox":"0 0 24 24","fill":"none"};

module.exports = BackArrow;

BackArrow.default = BackArrow;
